import React, { useEffect } from 'react'
import {
  Button,
  Card,
  CenteredSpinner,
  Col,
  Row,
  useToaster,
  useQueryParams,
  EmployeeService
} from '../../../index'
import { Link, useHistory, useParams } from 'react-router-dom'
import EmployeeProfileSidebar from './EmployeeProfileSidebar'
import { PersonalInformation, SectionContainer, DependentsRow } from './style'
import { useQuery } from 'react-query'
import { maskSsn } from '@angle/utils'

export const EmployerPortalEmployeeProfile: React.FC<{
  isBrokerPortal?: boolean
  employeeService: EmployeeService
}> = ({ isBrokerPortal, employeeService }) => {
  const { show } = useToaster()
  const history = useHistory()
  const query = useQueryParams()

  const { id, groupId } = useParams<{ id: string; groupId: string }>()

  const queryKey = ['employee', id]
  if (isBrokerPortal) {
    queryKey.push(groupId)
  }

  const { data: employee, isLoading } = useQuery(queryKey, () =>
    employeeService.getEmployeeProfile(id, isBrokerPortal ? groupId : '')
  )

  const condition = query.get('condition')
  const name = query.get('name')

  useEffect(() => {
    if (condition === 'new') {
      setTimeout(() => {
        show({
          message:
            'Robert Smith has been successfully added to the employee list',
          icon: 'icon-correct',
          type: 'success'
        })
      }, 200)
    }
    if (condition === 'new-dependant') {
      setTimeout(() => {
        show({
          message: `Dependent ${name} added succesfully`,
          icon: 'icon-correct',
          type: 'success'
        })
      }, 200)
    }
  }, [condition, name, show])

  if (isLoading) {
    return <CenteredSpinner />
  }

  return (
    <div className="d-flex flex-column" style={{ height: '100%' }}>
      <SectionContainer className="d-flex" style={{ height: '100%' }}>
        <EmployeeProfileSidebar
          employee={employee}
          complete={false}
          empty={false}
          isBrokerPortal={isBrokerPortal}
        />
        <div className="flex-grow-1" style={{ borderTop: '1px solid #E7EAF3' }}>
          <div style={{ padding: '30px 30px 30px' }}>
            <div>
              <h5 className="mb-4 d-flex justify-content-between">
                <span>Dependents</span>
              </h5>
              {employee?.dependents?.length ? (
                <DependentsRow className="mb-5">
                  {employee?.dependents?.map((d: any) => {
                    let path = `/employees/${employee.id}/dependents/${d.member_id}`

                    return (
                      <Col md={3} key={d.member_id}>
                        <Link
                          to={
                            isBrokerPortal ? `/groups/${groupId}${path}` : path
                          }
                        >
                          <Card style={{ minWidth: 200 }}>
                            <Card.Body className="d-flex justify-content-between">
                              <div>
                                <p className="mb-0">
                                  {d.name?.first_name} {d.name?.last_name}
                                </p>
                                <p className="mb-0 text-muted text-capitalize">
                                  {d.relationship}
                                </p>
                              </div>
                            </Card.Body>
                          </Card>
                        </Link>
                      </Col>
                    )
                  })}
                </DependentsRow>
              ) : (
                <div className="text-center">
                  <h5 className="text-black-50">No dependents added</h5>
                  <p className="text-black-50" style={{ opacity: 0.5 }}>
                    Dependents that you add will be listed here
                  </p>
                </div>
              )}
            </div>
            <div className="mt-5">
              <h5 className="mb-5 d-flex justify-content-between ">
                <span>Personal Information</span>
                <Button
                  variant="primary"
                  ghost
                  size="sm"
                  onClick={() =>
                    history.push(
                      isBrokerPortal
                        ? `/groups/${groupId}/employees/${id}/edit`
                        : `/employees/${id}/edit`
                    )
                  }
                >
                  Edit Information
                </Button>
              </h5>
              <Row>
                <Col md={6} sm={12}>
                  <PersonalInformation>
                    <p>Full Name</p>
                    <p>{employee?.name}</p>
                  </PersonalInformation>
                </Col>
                <Col md={6} sm={12}>
                  <PersonalInformation>
                    <p>Member ID</p>
                    <p>{employee?.id}</p>
                  </PersonalInformation>
                </Col>
                <Col md={6} sm={12}>
                  <PersonalInformation>
                    <p>Date of Birth</p>
                    <p>{employee?.dob}</p>
                  </PersonalInformation>
                </Col>
                <Col md={6} sm={12}>
                  <PersonalInformation>
                    <p>SSN</p>
                    <p>{maskSsn(employee?.ssn || '')}</p>
                  </PersonalInformation>
                </Col>
                <Col md={6} sm={12}>
                  <PersonalInformation>
                    <p>Email Address</p>
                    <p>{employee?.email}</p>
                  </PersonalInformation>
                </Col>
                <Col md={6} sm={12}>
                  <PersonalInformation>
                    <p>Medicare Eligible</p>
                    <p>{employee?.medicareEligible}</p>
                  </PersonalInformation>
                </Col>
                <Col md={6} sm={12}>
                  <PersonalInformation>
                    <p>Mailing Address</p>
                    <p className="text-right">{employee?.address}</p>
                  </PersonalInformation>
                </Col>
                <Col md={6} sm={12}>
                  <PersonalInformation>
                    <p>Other Insurance</p>
                    <p>{employee?.otherInsurance}</p>
                  </PersonalInformation>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </SectionContainer>
    </div>
  )
}
